(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.hero-slideshow__slide')];
        this.dots = [...this.querySelectorAll('[data-hero-dot]')];
        this.pauseButton = this.querySelector('[data-hero-pause]');
        this.index = 0;
        this.speed = Number(this.dataset.speed) || 6000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = false;
        this.hoverPaused = false;
        this.offscreen = false;
        if (this.slides.length < 2) return;

        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.index - 1, -1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.index + 1, 1));
        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            const target = Number(dot.dataset.heroDot);
            this.go(target, target > this.index ? 1 : -1);
          })
        );
        this.pauseButton?.addEventListener('click', () => this.toggleUserPause());

        // Keyboard: arrow keys when focus is inside the slider
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(this.index - 1, -1);
          if (event.key === 'ArrowRight') this.go(this.index + 1, 1);
        });

        // Pause while hovered or while something inside has keyboard focus
        this.addEventListener('mouseenter', () => this.setHover(true));
        this.addEventListener('mouseleave', () => this.setHover(false));
        this.addEventListener('focusin', () => this.setHover(true));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setHover(false);
        });

        this.bindSwipe();

        // Pause when the slider is off-screen or the tab is hidden
        this.observer = new IntersectionObserver(([entry]) => {
          this.offscreen = !entry.isIntersecting;
          this.updatePlayback();
        });
        this.observer.observe(this);
        this.onVisibility = () => this.updatePlayback();
        document.addEventListener('visibilitychange', this.onVisibility);

        // Theme editor: show the selected slide and hold it
        this.onBlockSelect = (event) => {
          const slide = event.target.closest?.('.hero-slideshow__slide');
          if (!slide || !this.contains(slide)) return;
          this.editorHold = true;
          this.go(Number(slide.dataset.index), 1);
        };
        this.onBlockDeselect = () => {
          this.editorHold = false;
          this.updatePlayback();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.updatePlayback();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      get canAutoplay() {
        return this.dataset.autoplay === 'true' && !this.reducedMotion;
      }

      get isPaused() {
        return this.userPaused || this.hoverPaused || this.offscreen || this.editorHold || document.hidden;
      }

      go(target, direction = 1) {
        const count = this.slides.length;
        const next = (target + count) % count;
        if (next === this.index) return;

        const current = this.slides[this.index];
        const incoming = this.slides[next];

        // Position the incoming slide on the side it enters from, without animating that jump
        incoming.classList.add('no-transition');
        incoming.style.setProperty('--from', String(direction));
        current.style.setProperty('--to', String(-direction));
        incoming.getBoundingClientRect();
        incoming.classList.remove('no-transition');

        this.slides.forEach((slide) => slide.classList.remove('is-leaving'));
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        current.setAttribute('aria-hidden', 'true');
        current.inert = true;

        incoming.classList.add('is-active');
        incoming.removeAttribute('aria-hidden');
        incoming.inert = false;

        clearTimeout(this.leaveTimer);
        this.leaveTimer = setTimeout(() => current.classList.remove('is-leaving'), 1200);

        this.dots.forEach((dot, i) => {
          const active = i === next;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.index = next;
        this.remaining = undefined;
        this.restartProgress();
        this.schedule();
      }

      // Restart the progress bar animation on the newly active dot
      restartProgress() {
        const fill = this.dots[this.index]?.querySelector('.hero-slideshow__dot-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        fill.getBoundingClientRect();
        fill.style.animation = '';
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.canAutoplay || this.isPaused) return;
        this.remaining = this.remaining ?? this.speed;
        this.startedAt = performance.now();
        this.timer = setTimeout(() => {
          this.remaining = undefined;
          this.go(this.index + 1, 1);
        }, this.remaining);
      }

      updatePlayback() {
        if (!this.canAutoplay) {
          this.classList.remove('is-playing', 'is-paused');
          return;
        }
        this.classList.add('is-playing');
        if (this.isPaused) {
          if (!this.classList.contains('is-paused') && this.startedAt !== undefined && this.remaining !== undefined) {
            // Remember how much of this slide's time is left so resuming continues where it stopped
            this.remaining = Math.max(400, this.remaining - (performance.now() - this.startedAt));
          }
          clearTimeout(this.timer);
          this.classList.add('is-paused');
        } else {
          this.classList.remove('is-paused');
          this.schedule();
        }
      }

      setHover(value) {
        this.hoverPaused = value;
        this.updatePlayback();
      }

      toggleUserPause() {
        this.userPaused = !this.userPaused;
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.setAttribute(
          'aria-label',
          this.userPaused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause
        );
        this.updatePlayback();
      }

      bindSwipe() {
        const frame = this.querySelector('.hero-slideshow__frame');
        let startX = 0;
        let startY = 0;
        let tracking = false;

        frame.addEventListener(
          'touchstart',
          (event) => {
            const touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            tracking = true;
          },
          { passive: true }
        );

        frame.addEventListener(
          'touchend',
          (event) => {
            if (!tracking) return;
            tracking = false;
            const touch = event.changedTouches[0];
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;
            // Horizontal swipe only (ignore vertical page scrolling)
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) {
              this.remaining = undefined;
              this.go(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
            }
          },
          { passive: true }
        );
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
